;(function () {
	const header = () => {
		$('[data-hover-opacity]').hover(
			function () {
				const id = $(this).data('hover-opacity')
				$(`[data-hover-opacity=${id}]`).addClass('opacity')
				$(this).removeClass('opacity')
			},
			function () {
				const id = $(this).data('hover-opacity')
				$(`[data-hover-opacity=${id}]`).removeClass('opacity')
			}
		)

		const megaMenuTabs = () => {
			/**
			 * Lock tab area height to the tallest panel so switching tabs
			 * (including ones with more items) does not resize the mega menu.
			 * @param {HTMLElement} megaMenu
			 */
			const lockMegaMenuTabAreaHeight = (megaMenu) => {
				const tabs = megaMenu.querySelector('.mega-menu__tabs')
				if (!tabs) return

				if (!tabs.dataset.baseMinHeight) {
					tabs.dataset.baseMinHeight = getComputedStyle(tabs).minHeight
				}

				const baseMinHeight =
					Number.parseFloat(tabs.dataset.baseMinHeight) || 0
				const panels = tabs.querySelectorAll('[role="tabpanel"]')
				let maxPanelHeight = 0

				panels.forEach((panel) => {
					maxPanelHeight = Math.max(maxPanelHeight, panel.scrollHeight)
				})

				tabs.style.minHeight = `${Math.max(baseMinHeight, maxPanelHeight)}px`
			}

			/** @param {HTMLElement} wrapper */
			const activateMegaMenuTab = function (wrapper) {
				const $wrapper = $(wrapper)
				const $megaMenu = $wrapper.closest('.mega-menu--tabs')
				const $wrappers = $megaMenu.find('.mega-menu__tab-wrapper')

				$wrappers.removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$wrappers.find('[role="tab"]').attr('aria-selected', 'false')
				$wrappers
					.find('[role="tabpanel"]')
					.attr('aria-hidden', 'true')
					.attr('inert', '')
				$wrapper.addClass('mega-menu__tab-wrapper--active')
				$wrapper.find('[role="tab"]').attr('aria-selected', 'true')
				$wrapper
					.find('[role="tabpanel"]')
					.attr('aria-hidden', 'false')
					.removeAttr('inert')

				const tabIndex = $wrapper.data('tab-index')
				const $images = $wrapper
					.closest('.mega-menu--tabs')
					.find('.mega-menu__tab-image')
				if ($images.length) {
					$images.removeClass('mega-menu__tab-image--active')
					$images
						.filter(`[data-tab-index="${tabIndex}"]`)
						.addClass('mega-menu__tab-image--active')
				}
			}

			$('.mega-menu__tab-wrapper').mouseenter(function (event) {
				activateMegaMenuTab(this)
			})
			$('.mega-menu__tab-wrapper').focus(function (event) {
				activateMegaMenuTab(this)
			})
			$('.mega-menu__tab-wrapper').focusin(function (event) {
				activateMegaMenuTab(this)
			})
			$('.mega-menu__tab-heading').click(function () {
				const wrapper = $(this).closest('.mega-menu__tab-wrapper')[0]
				if (wrapper) activateMegaMenuTab(wrapper)
			})
			$('.mega-menu--tabs').each(function () {
				const megaMenu = this
				const wrapper = megaMenu.querySelector(
					'.mega-menu__tab-wrapper--active'
				)
				if (wrapper) activateMegaMenuTab(wrapper)
				lockMegaMenuTabAreaHeight(megaMenu)

				// Re-measure after images settle (collection thumbs can change row height)
				megaMenu.querySelectorAll('img').forEach((img) => {
					if (img.complete) return
					img.addEventListener(
						'load',
						() => lockMegaMenuTabAreaHeight(megaMenu),
						{ once: true }
					)
				})

				// First open is a reliable measure point (fonts/layout fully settled)
				const hostItem = megaMenu.closest('.header__list > li')
				if (hostItem) {
					hostItem.addEventListener(
						'mouseenter',
						() => lockMegaMenuTabAreaHeight(megaMenu),
						{ once: true }
					)
				}
			})

			let resizeFrame = 0
			window.addEventListener('resize', () => {
				cancelAnimationFrame(resizeFrame)
				resizeFrame = requestAnimationFrame(() => {
					document
						.querySelectorAll('.mega-menu--tabs')
						.forEach((megaMenu) => {
							const tabs = megaMenu.querySelector('.mega-menu__tabs')
							if (tabs) delete tabs.dataset.baseMinHeight
							lockMegaMenuTabAreaHeight(megaMenu)
						})
				})
			})
		}
		megaMenuTabs()

		const headerElement = document.querySelector('.header-main-section')

		if (
			headerElement &&
			headerElement.classList.contains('color-background-overlay')
		) {
			headerElement.addEventListener('mouseenter', () => {
				headerElement.classList.remove('color-background-overlay')
				headerElement.classList.remove('color-background-4')
			})
			headerElement.addEventListener('mouseleave', () => {
				headerElement.classList.add('color-background-overlay')
				if (headerElement.classList.contains('overlay-effect')) {
					headerElement.classList.add('color-background-1')
				} else {
					headerElement.classList.add('color-background-4')
				}
			})
		}
	}

	/** @param {EventTarget | null} target */
	const openMegaMenuInEditor = (target) => {
		document
			.querySelectorAll('.header__list li.mega-menu--force-open')
			.forEach((item) => item.classList.remove('mega-menu--force-open'))

		const megaMenu =
			target instanceof Element && target.classList.contains('header-mega-menu')
				? target
				: target instanceof Element
					? target.closest('.header-mega-menu')
					: null

		megaMenu?.closest('li')?.classList.add('mega-menu--force-open')
	}

	/** @param {EventTarget | null} target */
	const closeMegaMenuInEditor = (target) => {
		const megaMenu =
			target instanceof Element && target.classList.contains('header-mega-menu')
				? target
				: target instanceof Element
					? target.closest('.header-mega-menu')
					: null

		megaMenu?.closest('li')?.classList.remove('mega-menu--force-open')
	}

	document.addEventListener('shopify:block:select', (event) => {
		openMegaMenuInEditor(event.target)
	})

	document.addEventListener('shopify:block:deselect', (event) => {
		closeMegaMenuInEditor(event.target)
	})

	document.addEventListener('shopify:section:load', header)
	header()
})()
